import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1033RegGesAnteileStatus: 'idle',
    startProcess1033RegGesAnteileError: undefined as any,
    loadUserParamsProcess1033RegGesAnteileStatus: 'idle',
    loadUserParamsProcess1033RegGesAnteileError: undefined as any,

    process1033RegGesAnteileList: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1033RegGesAnteile = createAsyncThunk('process1033RegGesAnteileSlice/startProcess1033RegGesAnteile', async ({ process1033RegGesAnteile }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1033RegGesAnteile/`,
        prepareData(process1033RegGesAnteile),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1033RegGesAnteileStatus } = getState().process1033RegGesAnteileSlice
        return startProcess1033RegGesAnteileStatus !== 'pending'
    }
})

export const loadUserParamsProcess1033RegGesAnteile = createAsyncThunk('process1033RegGesAnteileSlice/loadUserParamsProcess1033RegGesAnteile', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1033RegGesAnteile/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1033RegGesAnteileStatus } = getState().process1033RegGesAnteileSlice
        return loadUserParamsProcess1033RegGesAnteileStatus !== 'pending'
    }
})

const Process1033RegGesAnteileSlice = createSlice({
    name: 'process1033RegGesAnteileSlice',
    initialState,
    reducers: {
        resetstartProcess1033RegGesAnteile: (state) => {
            state.job = undefined
            state.startProcess1033RegGesAnteileError = undefined
        },
        resetstartProcess1033RegGesAnteileError: (state) => {
            state.startProcess1033RegGesAnteileError = undefined
        },
        resetloadUserParamsProcess1033RegGesAnteile: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1033RegGesAnteileError = undefined
        },
        resetloadUserParamsProcess1033RegGesAnteileError: (state) => {
            state.loadUserParamsProcess1033RegGesAnteileError = undefined
        },
        removeFromProcess1033RegGesAnteileListById: (state, action) => {
            state.process1033RegGesAnteileList = state.process1033RegGesAnteileList.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1033RegGesAnteileListByIds: (state, action) => {
            state.process1033RegGesAnteileList = state.process1033RegGesAnteileList.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1033RegGesAnteileList = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1033RegGesAnteileStatus = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1033RegGesAnteileList = []
            state.startProcess1033RegGesAnteileStatus = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1033RegGesAnteile.pending, (state) => {
            state.startProcess1033RegGesAnteileStatus = 'pending'
            state.startProcess1033RegGesAnteileError = undefined
        })
        builder.addCase(startProcess1033RegGesAnteile.fulfilled, (state, action) => {
            state.startProcess1033RegGesAnteileStatus = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1033RegGesAnteile.rejected, (state, action) => {
            state.startProcess1033RegGesAnteileStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1033RegGesAnteileError = action.error.message
            } else {
                state.startProcess1033RegGesAnteileError = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1033RegGesAnteile.pending, (state) => {
            state.loadUserParamsProcess1033RegGesAnteileStatus = 'pending'
            state.loadUserParamsProcess1033RegGesAnteileError = undefined
        })
        builder.addCase(loadUserParamsProcess1033RegGesAnteile.fulfilled, (state, action) => {
            state.loadUserParamsProcess1033RegGesAnteileStatus = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1033RegGesAnteile.rejected, (state, action) => {
            state.loadUserParamsProcess1033RegGesAnteileStatus = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1033RegGesAnteileError = action.error.message
            } else {
                state.loadUserParamsProcess1033RegGesAnteileError = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1033RegGesAnteile,
    resetstartProcess1033RegGesAnteileError,
    resetloadUserParamsProcess1033RegGesAnteile,
    resetloadUserParamsProcess1033RegGesAnteileError,
    removeFromProcess1033RegGesAnteileListById,
    removeFromProcess1033RegGesAnteileListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1033RegGesAnteileSlice.actions
export default Process1033RegGesAnteileSlice.reducer
